import { render } from "./AttendStudentList.vue?vue&type=template&id=589628be&scoped=true"
import script from "./AttendStudentList.vue?vue&type=script&lang=js"
export * from "./AttendStudentList.vue?vue&type=script&lang=js"

import "./AttendStudentList.vue?vue&type=style&index=0&id=589628be&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2_check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589628be"]])

export default __exports__